import {
    GET_USERS,
    SET_PAGE,
    SET_ROWS,
    REMOVE_USER,
    SET_USER_TYPE_FILTER,
    REMOVE_CREW_USER,
    SET_PROFILE,
    GET_DEPARTMENTS,
    GET_AREAS,
    SET_FILTER_DEPARTMENT_NAME,
    SET_FILTER_AREA_NAME,
    SET_LAST_ACTIVE,
    SET_NEW_USER,
    SET_USER_FILTER,
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";

export const getUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_USERS.FAIL });
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};

export const setPage = (page = 0) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};
export const setProfile = (profile = false) => {
    return (dispatch) => {
        dispatch({ type: SET_PROFILE, payload: profile });
    };
};
export const setRow = (row = 50) => {
    return (dispatch) => {
        dispatch({ type: SET_ROWS, payload: row });
    };
};

export const removeUser = (uid, callback) => {
    return (dispatch) => {
        dispatch({ type: REMOVE_USER.REQUEST, payload: true });
        let cloudFunction = firebase.functions().httpsCallable("removeUser");
        try {
            cloudFunction(uid).then((e) => {
                firebase
                    .database()
                    .ref("/collections/seated_users")
                    .on("value", (snap) => {
                        let userSeats = snap.val() || [];
                        let flag = false;
                        userSeats &&
                            userSeats.map((e) => {
                                if (uid === e) flag = uid;
                                return null;
                            });
                            
                        if (flag) {
                            userSeats = userSeats.splice(
                                userSeats.findIndex(flag),
                                1
                            );
                            firebase
                                .database()
                                .ref("/collections/seated_users/")
                                .set(userSeats);
                        }
                    });

                dispatch({ type: REMOVE_USER.SUCCESS, payload: false });
                callback(true);
            });
        } catch (e) {
            dispatch({ type: REMOVE_USER.FAIL });
            callback(false);
        }
    };
};
export const setUserTypeFilter = (filter = "admin") => {
    return (dispatch) => {
        dispatch({ type: SET_USER_TYPE_FILTER, payload: filter });
    };
};
export const removeCrewUser = (uid = false, successCallback) => {
    return (dispatch) => {
        dispatch({ type: REMOVE_CREW_USER.REQUEST });
        if (uid) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase.database().ref(`/users/${uid}`).remove();
                    } else {
                        dispatch({ type: REMOVE_CREW_USER.FAIL });
                    }
                });
            } catch {
                dispatch({ type: REMOVE_CREW_USER.FAIL });
            }
        } else {
            dispatch({ type: REMOVE_CREW_USER.FAIL });
        }
    };
};

export const getDepartments = () => {
    return (dispatch) => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return (dispatch) => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};
export const setFilterAreaName = (areaType = "all_areas") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_AREA_NAME, payload: areaType });
    };
};
export const setLastActive = (lastActive) => {
    return (dispatch) => {
        dispatch({ type: SET_LAST_ACTIVE, payload: lastActive });
    };
};
export const setNewUser = (newuser, password, callback) => {
    return (dispatch) => {
        dispatch({ type: SET_NEW_USER.REQUEST });
        if (password.length >= 6) {
            let cloudFunction = firebase.functions().httpsCallable("addUser");
            cloudFunction({ newuser, password }).then((e) => {
                firebase
                    .database()
                    .ref("/collections/seated_user_limit")
                    .once("value", (snapshot) => {
                        let limit = snapshot.val();
                        firebase
                            .database()
                            .ref("/collections/seated_users")
                            .once("value", (snap) => {
                                let userSeats = snap.val();
                                if (userSeats)
                                    userSeats = [...userSeats, e.data.uid];
                                if (limit >= userSeats.length)
                                    firebase
                                        .database()
                                        .ref("/collections/seated_users/")
                                        .set(userSeats);
                            });
                    });
                dispatch({
                    type: SET_NEW_USER.SUCCESS,
                    payload: false,
                });
                callback(true);
            });
        } else {
            dispatch({ type: SET_NEW_USER.FAIL, payload: false });
            callback(false);
        }
    };
};
export const setFilterDepartmentsName = (
    departmentType = "all_departments"
) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_DEPARTMENT_NAME, payload: departmentType });
    };
};
export const setUserFilter = (filter = false) => {
    return (dispatch) => {
        dispatch({ type: SET_USER_FILTER, payload: filter });
    };
};
